<template>
    <div>
        <p class="mb-1 body-1 text-capitalize" v-if="!isReaction">{{ category.value }}</p>
        <img
                :src="category.img"
                height="19px"
                v-else
                width="19px"
        />
        <!--                 style="font-size: 18px;"   -->
        <p
                :style="{color: !isReaction ? categoryColor[category.value] : '#000', fontSize: isReaction ? '0.8em' : '18px' }"
                class="font-weight-bold description--color"
        >
            {{ category.count | abbrNumber}}
        </p>
    </div>
</template>

<script>
	import {abbrNum} from "@/utils";

	export default {
		props: {
			category: {
				required: true
			},

			isReaction: {
				type: Boolean,
				required: true
			},

			categoryColor: {
				type: Object,
				required: true,
			}
		},

		filters: {
			abbrNumber(num) {
				return abbrNum(num, 2);
			}
		}
	};
</script>

<style scoped>
</style>
